
















































































































































































































































































































import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { dateToDisplay } from '@/utils/dateTime'
import { billingType, billingTypeKeys, payerType, billingTypeValues } from '@/modules/Policy/helpers/policy'
import { QuoteRequestCompanyType } from '@/modules/Quote/interfaces/quote'
import { QuoteCarrier } from '@/modules/Quote/interfaces/quote-carrier'
import FoldingCard from '@/components/FoldingCard.vue'
import AppHorizontalSlideController from '@/components/AppHorizontalSlideController.vue'
import AppSimpleTextSearch from '@/components/AppSimpleTextSearch.vue'
import SearchCarrier from '@/mixins/search-queries/search-carrier'
import AppDatePicker from '@/components/AppDatePicker.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppDialog from '@/components/AppDialog.vue'
import PolicyDialog from '@/modules/Policy/scripts/policy-dialog'
import { deleteQuotePremium, updateDeniedReasons } from '@/modules/Quote/gql/quote.gql'
import QuoteRequestTypeInForm from '@/modules/Quote/components/QuoteRequestTypeInForm.vue'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import dollarFilter from '@/utils/dollarFilter'
import { QuoteWithPremium } from '@/modules/Quote/interfaces/quote-with-premium'
import AppCheckboxRed from '@/components/AppCheckboxRed.vue'
import AppTextarea from '@/components/AppTextarea.vue'

interface CarrierOrGA {
  type: QuoteRequestCompanyType
  gaId?: number
  gaName?: string
  carriers: QuoteCarrier[]
}

@Component({
  components: {
    FoldingCard,
    AppHorizontalSlideController,
    AppSimpleTextSearch,
    AppTextField,
    AppSelector,
    AppDatePicker,
    AppDialog,
    QuoteRequestTypeInForm,
    AppCheckboxRed,
    AppTextarea
  }
})
export default class QuotePremiumInfo extends mixins(SearchCarrier, PolicyDialog) {
  @Prop({ type: Object as () => QuoteWithPremium }) readonly quote!: QuoteWithPremium
  @Prop({ type: Boolean }) readonly noGenerateBtn!: boolean

  topTabActiveIdx = 0
  topTabTransIdx = 0
  topTabToDeleteIdx = -1

  dollarFilter = dollarFilter

  premiumMap: CarrierOrGA[] = []

  topTabs: {
    name: string;
    type: string;
  }[] = []

  disableTopLeft = false
  disableTopRight = false

  secTabActiveIdx = 0
  secTabTransIdx = 0

  secTabs: string[] = []

  disableSecLeft = false
  disableSecRight = false

  requestDialog = {
    title: 'Request Quote From (Type In)',
    show: false,
    disable: false,
    step: 0
  }

  secTabEdit = {
    idx: -1,
    top: 19,
    left: 0,
    type: 'edit'
  }

  deleteDialog = {
    show: false,
    type: '',
    name: '',
    isTop: false
  }

  addNewCarrier = false
  ifDenied = false
  showDeniedEditor = false
  deniedReasonInput = ''

  dateToDisplay = dateToDisplay
  billingType = billingType
  payerType = payerType
  billingTypeOptions = billingTypeValues
  billingTypeKeys = billingTypeKeys

  get topTabsWidth () {
    return this.topTabs.length * 160
  }

  get topTabsTranslateX () {
    return `translateX(${this.topTabTransIdx * 206}px)`
  }

  get secTabsWidth () {
    return this.secTabs.length * 315 + 46
  }

  get secTabsTranslateX () {
    return `translateX(${this.secTabTransIdx * 315}px)`
  }

  get showSecTab () {
    const { quote: { premiums }, getPremiumInfo } = this

    if (!getPremiumInfo) {
      return false
    }

    if (premiums.length === 0) {
      return false
    }

    return !!getPremiumInfo.gaId
  }

  get totalTermAmount () {
    let totalNum = '0.00'
    const { premium, agencyFee, carrierPolicyFee, inspectionFee, stampingFee, taxesFee, brokerFee } = this.getPremiumInfo
    const premiumNum = premium ? Number(premium) : 0
    const agencyFeeNum = agencyFee ? Number(agencyFee) : 0
    const carrierPolicyFeeNum = carrierPolicyFee ? Number(carrierPolicyFee) : 0
    const inspectionFeeNum = inspectionFee ? Number(inspectionFee) : 0
    const stampingFeeNum = stampingFee ? Number(stampingFee) : 0
    const taxesFeeNum = taxesFee ? Number(taxesFee) : 0
    const brokerFeeNum = brokerFee ? Number(brokerFee) : 0
    totalNum = (premiumNum + agencyFeeNum + carrierPolicyFeeNum + inspectionFeeNum + stampingFeeNum + taxesFeeNum + brokerFeeNum).toFixed(2)
    return totalNum
  }

  get totalProjectCommission () {
    const { commission, premium } = this.getPremiumInfo

    if (!commission || isNaN(Number(commission)) || !premium || isNaN(Number(premium))) {
      return '0.00'
    }

    return (Number(premium) * Number(commission) / 100).toFixed(2)
  }

  get quoteWithPremium () {
    const { quote, topTabActiveIdx, secTabActiveIdx, addNewCarrier } = this

    if (this.premiumMap.length === 0) {
      return null
    }

    const premiumInfo = this.premiumMap[topTabActiveIdx]

    if (addNewCarrier) {
      return Object.assign({}, quote, {
        premiumInfo: {
          gaId: premiumInfo.gaId,
          gaName: premiumInfo.gaName
        }
      })
    }

    if (premiumInfo.type === QuoteRequestCompanyType.GA) {
      return Object.assign({}, quote, {
        premiumInfo: premiumInfo.carriers[secTabActiveIdx]
      })
    } else {
      return Object.assign({}, quote, {
        premiumInfo: premiumInfo.carriers[0]
      })
    }
  }

  get getPremiumInfo (): QuoteCarrier {
    const { topTabActiveIdx, secTabActiveIdx } = this

    if (this.premiumMap.length === 0) {
      return {} as QuoteCarrier
    }
    const info = this.premiumMap[topTabActiveIdx]

    if (info.type === QuoteRequestCompanyType.GA) {
      this.deniedReasonInput = info.carriers[secTabActiveIdx].deniedReasons
      this.ifDenied = info.carriers[secTabActiveIdx].ifDenied

      return info.carriers[secTabActiveIdx]
    } else {
      this.deniedReasonInput = info.carriers[0].deniedReasons
      this.ifDenied = info.carriers[0].ifDenied
      return info.carriers[0]
    }
  }

  get canGeneratePolicy () {
    return !(this.quote.priorTerm && this.quote.priorTerm.inheritPolicies.toPolicy)
  }

  async mounted () {
    this.onQuoteChanged(this.quote)
  }

  @Watch('quote', { deep: true })
  onQuoteChanged (val: QuoteWithPremium) {
    this.clearTabs()
    const premiums = val.premiums
    for (const qc of premiums) {
      if (qc.gaId && qc.gaId !== -1) {
        const idx = this.topTabs.findIndex(tab => tab.name === qc.gaName)
        if (idx === -1) {
          this.premiumMap.push({
            type: QuoteRequestCompanyType.GA,
            gaId: qc.gaId,
            gaName: qc.gaName,
            carriers: [qc]
          })
          this.topTabs.push({
            name: qc.gaName,
            type: 'GA'
          })
        } else {
          this.premiumMap[idx].carriers.push(qc)
        }
      } else {
        this.premiumMap.push({
          type: QuoteRequestCompanyType.CARRIER,
          carriers: [qc]
        })
        this.topTabs.push({
          name: qc.carrierName,
          type: 'Direct'
        })
      }
    }
    this.topTabActiveIdx = 0
    this.topTabClickHandler(0)
  }

  clearTabs () {
    this.premiumMap = []
    this.topTabs = []
    this.secTabs = []
    this.topTabActiveIdx = 0
    this.topTabTransIdx = 0
    this.secTabActiveIdx = 0
    this.secTabTransIdx = 0
  }

  topTabClickHandler (i: number) {
    this.cancelCarrierRequest()
    this.topTabActiveIdx = i
    if (this.topTabs.length === 0) {
      return
    }

    const info = this.premiumMap[i]

    this.secTabs = info.carriers.map(carrier => carrier.carrierName)
  }

  topTabLeftHandler () {
    this.disableTopLeft = this.topTabTransIdx >= 0
    if (!this.disableTopLeft) {
      this.topTabTransIdx += 1
      this.disableTopRight = false
    }
  }

  topTabRightHandler () {
    const elem = (this.$refs.toptabs as Vue & { offsetWidth: number; })

    const totalWidth = elem.offsetWidth - 82

    const offset = (this.topTabs.length + this.topTabTransIdx) * 206
    this.disableTopRight = totalWidth >= offset

    if (!this.disableTopRight) {
      this.topTabTransIdx -= 1
      this.disableTopLeft = false
    }
  }

  secTabClickHandler (i: number) {
    if (this.secTabEdit.type !== '') {
      this.cancelCarrierRequest()
    }
    this.secTabActiveIdx = i >= this.secTabs.length
      ? this.secTabs.length - 1
      : i
  }

  secTabLeftHandler () {
    this.disableTopLeft = this.secTabTransIdx >= 0
    if (!this.disableTopLeft) {
      this.secTabTransIdx += 1
      this.disableTopRight = false
    }
  }

  secTabRightHandler () {
    const elem = (this.$refs.toptabs as Vue & { offsetWidth: number; })

    const totalWidth = elem.offsetWidth - 82

    const offset = (this.secTabs.length + this.secTabTransIdx) * 315
    this.disableTopRight = totalWidth >= offset

    if (!this.disableTopRight) {
      this.secTabTransIdx -= 1
      this.disableTopLeft = false
    }
  }

  editCarrierRequest () {
    this.requestDialog.show = true
  }

  cancelCarrierRequest () {
    this.secTabEdit.left = 0
    this.secTabEdit.idx = -1

    if (this.secTabEdit.type === 'new') {
      this.secTabs = this.$R.drop(1, this.secTabs)
    }
    this.secTabEdit.type = ''
  }

  newCarrierRequest () {
    this.addNewCarrier = true
    this.editCarrierRequest()
  }

  deletePremiumInfo (topIndex?: number) {
    const { topTabActiveIdx, secTabActiveIdx } = this

    if (topIndex !== null && topIndex !== undefined) {
      const premium = this.premiumMap[topIndex]
      if (!premium) {
        return
      }
      this.topTabToDeleteIdx = topIndex
      if (premium.type === QuoteRequestCompanyType.GA) {
        this.deleteDialog.type = 'GA'
        this.deleteDialog.name = premium.carriers[0].gaName
      } else {
        this.deleteDialog.type = 'Carrier'
        this.deleteDialog.name = premium.carriers[0].carrierName
      }
    } else {
      this.topTabToDeleteIdx = 0
      const premium = this.premiumMap[topTabActiveIdx]
      const info = premium.carriers[secTabActiveIdx]
      this.deleteDialog.type = 'Carrier'
      this.deleteDialog.name = info.carrierName
    }

    this.deleteDialog.isTop = topIndex !== null && topIndex !== undefined
    this.deleteDialog.show = true
  }

  async confirmDeleteQuoteRequestPost () {
    const { topTabActiveIdx, secTabActiveIdx, deleteDialog, quote, topTabToDeleteIdx } = this

    const { type, isTop } = deleteDialog

    const premium = topTabToDeleteIdx === -1
      ? this.premiumMap[topTabActiveIdx]
      : this.premiumMap[topTabToDeleteIdx]

    const quoteId = Number(quote.id)
    const gaId = premium.carriers[secTabActiveIdx].gaId

    const carrierId = isTop && type === 'GA'
      ? null
      : premium.carriers[secTabActiveIdx].carrierId

    const relationId = isTop && type === 'GA'
      ? null
      : Number(premium.carriers[secTabActiveIdx].id)

    this.deleteDialog.show = false

    try {
      const res = await this.$apollo.mutate({
        mutation: deleteQuotePremium,
        variables: {
          quoteId,
          carrierId,
          gaId,
          relationId
        }
      })
      this.onSuccess('Delete quote premium information successfully', 'delete')
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  @Emit('success')
  onSuccess (msg = '', action: string) {
    if (msg) {
      showNotification({
        msg,
        type: SnackType.Success
      })
    }

    this.addNewCarrier = false
  }

  onDeniedClick (ifChecked: boolean) {
    if (ifChecked) {
      this.showTextInput()
    } else {
      this.updateDeniedReasonRequestPost(false)
    }
  }

  showTextInput () {
    this.showDeniedEditor = true
    this.deniedReasonInput = this.getPremiumInfo.deniedReasons || ''
  }

  cancelDeny () {
    const { deniedReasons, ifDenied } = this.getPremiumInfo
    this.showDeniedEditor = false
    this.deniedReasonInput = deniedReasons || ''
    this.ifDenied = ifDenied
  }

  async updateDeniedReasonRequestPost (ifDenied: boolean) {
    const { getPremiumInfo, deniedReasonInput } = this
    try {
      await this.$apollo.mutate({
        mutation: updateDeniedReasons,
        variables: {
          relationId: +getPremiumInfo.id,
          deniedReasons: deniedReasonInput,
          ifDenied
        }
      })

      this.showDeniedEditor = false
      this.deniedReasonInput = ''

      if (deniedReasonInput.length) {
        this.onSuccess('Update denied reasons successfully', 'update')
      } else {
        this.onSuccess('Remove denied reasons successfully', 'delete')
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  generateLines (str: string) {
    return str.split('\n')
  }
}
